import React from 'react';
import { Calendar, MapPin } from 'lucide-react';
import { Show } from '../types';
import { formatDate } from '../utils/dateUtils';

interface ShowsListProps {
  shows: Show[];
}

const ShowsList: React.FC<ShowsListProps> = ({ shows }) => {
  return (
    <div className="bg-gray-800 rounded-lg p-6 sticky top-24" style={{backgroundColor: '#111827'}}>
      <h3 className="text-2xl font-bold mb-6 flex items-center">
        <Calendar size={24} className="mr-2 text-red-600" />
        Tour Dates
      </h3>
      <ul className="space-y-4" id="shows">
        {shows.map((show) => (
          <li key={show.id} className="transition-all hover:translate-x-1">
            <a 
              href={`#show-${show.id}`}
              className="block p-4 bg-gray-700 hover:bg-gray-600 rounded-lg transition-all" style={{backgroundColor: '#1F2937'}}
            >
              <div className="text-lg text-red-600">{formatDate(show.date)}</div>
              <div className="text-lg">{show.city}</div>
              <div className="flex items-center text-gray-300 mt-1">
                <MapPin size={16} className="mr-1" />
                {show.venue}
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShowsList;